import { useEffect, useState } from 'react';

/** Kiosk behaviour for the shop TV: keep the screen awake, hide the idle cursor, enter fullscreen on first tap. */
export function useKiosk() {
  useEffect(() => {
    let lock: { release: () => Promise<void> } | null = null;
    const nav = navigator as Navigator & { wakeLock?: { request: (t: 'screen') => Promise<{ release: () => Promise<void> }> } };
    const requestLock = async () => { try { lock = (await nav.wakeLock?.request('screen')) ?? null; } catch { /* unsupported */ } };
    void requestLock();
    const onVisible = () => { if (document.visibilityState === 'visible') void requestLock(); };
    document.addEventListener('visibilitychange', onVisible);

    let idle: ReturnType<typeof setTimeout>;
    const showCursor = () => {
      document.body.classList.remove('hide-cursor');
      clearTimeout(idle);
      idle = setTimeout(() => document.body.classList.add('hide-cursor'), 3_000);
    };
    window.addEventListener('mousemove', showCursor);
    showCursor();

    const goFullscreen = () => { if (!document.fullscreenElement) void document.documentElement.requestFullscreen?.().catch(() => undefined); };
    window.addEventListener('click', goFullscreen);
    return () => {
      document.removeEventListener('visibilitychange', onVisible);
      window.removeEventListener('mousemove', showCursor);
      window.removeEventListener('click', goFullscreen);
      clearTimeout(idle);
      void lock?.release().catch(() => undefined);
    };
  }, []);
}

export function useNow(intervalMs = 1_000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => { const t = setInterval(() => setNow(Date.now()), intervalMs); return () => clearInterval(t); }, [intervalMs]);
  return now;
}
